import { render, staticRenderFns } from "./SummaryLeadsStatusCard.vue?vue&type=template&id=135ac0a8&scoped=true"
import script from "./SummaryLeadsStatusCard.vue?vue&type=script&lang=js"
export * from "./SummaryLeadsStatusCard.vue?vue&type=script&lang=js"
import style0 from "./SummaryLeadsStatusCard.vue?vue&type=style&index=0&id=135ac0a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135ac0a8",
  null
  
)

export default component.exports